import { render, staticRenderFns } from "./task.vue?vue&type=template&id=11151ace&scoped=true"
import script from "./task.vue?vue&type=script&lang=js"
export * from "./task.vue?vue&type=script&lang=js"
import style0 from "./task.vue?vue&type=style&index=0&id=11151ace&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11151ace",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Workplace\\vueProject\\edu_aim\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('11151ace')) {
      api.createRecord('11151ace', component.options)
    } else {
      api.reload('11151ace', component.options)
    }
    module.hot.accept("./task.vue?vue&type=template&id=11151ace&scoped=true", function () {
      api.rerender('11151ace', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/hwk/task.vue"
export default component.exports